import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { useAuth } from '../../Context/Auth/Context';
import { signInWithGooglePopup, signOutUser } from '../../firebaseSetup';
import React from 'react';

export const User: React.FC = () => {
  const auth = useAuth();

  const onSignInButtonClick = () => {
    signInWithGooglePopup().then(result => {
      console.log(result);
    });
  };

  return (
    <div>
      {auth ? (
        <>
          <h1>Welcome, {auth.displayName}</h1>
          <h1>Email: {auth.email}</h1>
          <PrimaryButton onClick={signOutUser}>Sign out</PrimaryButton>
        </>
      ) : (
        <DefaultButton onClick={onSignInButtonClick}>Sign in with Google</DefaultButton>
      )}
    </div>
  );
};
